import Button from "@common/components/Button";
import Dialog from "@common/components/Dialog";
import DialogActions from "@common/components/Dialog/DialogActions";
import DialogTitle from "@common/components/Dialog/DialogTitle";
import Typography from "@common/components/Typography";
import { WarningAmberRounded } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Using texts specific to the import page for now, as it's only used there
 * Won't be hard to have a DialogProps on the Breadcrumb component
 * to carry that over if that ever gets used anywhere else.
 */
const BackModal = ({
  open,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle severity="warning">
        <>
          <WarningAmberRounded />
          {t("Leave Import?")}
        </>
      </DialogTitle>
      <Typography sx={{ px: 3 }}>
        {t("Are you sure you want to leave the import page?")}
      </Typography>
      <Typography sx={{ px: 3 }}>
        {t("All current data will be lost.")}
      </Typography>
      <DialogActions>
        <Button color="greyed" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="white" onClick={onConfirm}>
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BackModal;
